import update from 'immutability-helper';
import findIndex from 'lodash/findIndex';
import flow from 'lodash/fp/flow';
import { EDITOR } from 'constants/actionTypes';

import { removeId, sortAndUpdatePositions, resetPositions } from 'utils/fp';

const getSections = (sections = [], action) => {
  switch (action.type) {
    case EDITOR.SECTION.CREATE: {
      const { elements, ...rest } = action.payload;
      return [...sections, rest];
    }

    case EDITOR.SECTION.UPDATE: {
      const { id, type, ...changes } = action;
      const index = findIndex(sections, { id });
      const section = { ...sections[index], ...changes };
      return [
        ...sections.slice(0, index),
        section,
        ...sections.slice(index + 1),
      ];
    }

    case EDITOR.SECTION.DUPLICATE: {
      const duplicateSection = action.payload;
      const { position } = duplicateSection;
      const index = position - 1;

      return [
        ...sections.slice(0, index),
        duplicateSection,
        ...sections
          .slice(index)
          .map(section => ({ ...section, position: section.position + 1 })),
      ];
    }

    case EDITOR.SECTION.REORDER: {
      const { ownIndex, overIndex } = action;
      const section = sections[ownIndex];
      const newSections = update(sections, {
        $splice: [
          [ownIndex, 1],
          [overIndex, 0, section],
        ],
      });
      return resetPositions(newSections);
    }

    case EDITOR.SECTION.DELETE:
      return flow(removeId(action.id), sortAndUpdatePositions)(sections);

    default:
      return sections;
  }
};

export default getSections;
